"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _addonKnobs = require("@storybook/addon-knobs");

var _defaultProps = require("../defaultProps");

var _defaultProps2 = _interopRequireDefault(_defaultProps);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var BaseHelper = function () {
  function BaseHelper() {
    _classCallCheck(this, BaseHelper);

    this.getRequestOptions = function (requestData, config) {
      var publicHeader = config.publicHeader,
          proxyURL = config.proxyURL;
      var uri = requestData.uri,
          _requestData$method = requestData.method,
          method = _requestData$method === undefined ? "GET" : _requestData$method,
          _requestData$data = requestData.data,
          data = _requestData$data === undefined ? "" : _requestData$data;


      var apiPayload = {
        headers: publicHeader,
        json: true,
        method: method,
        body: data,
        uri: encodeURI(uri)
      };

      // convertedPayload,
      var options = {
        method: "POST",
        data: apiPayload,
        url: proxyURL
      };

      return options;
    };

    this.getQueryParams = function (location, queryParams) {
      var search = location.search;

      var trimmedSearch = search.trim();
      var params = new URLSearchParams(trimmedSearch);
      Object.keys(queryParams).forEach(function (key) {
        params.set(key, queryParams[key]);
      });
      search = params.toString();
      return search.replace("%40", "@");
    };

    this.removeQueryParams = function (location, key) {
      var pathname = location.pathname,
          search = location.search;


      var sourceURL = "" + pathname + search;

      var url = sourceURL.split("?")[0];
      var param = void 0;
      var paramArr = [];

      var queryString = sourceURL.indexOf("?") !== -1 ? sourceURL.split("?")[1] : "";

      if (queryString !== "") {
        paramArr = queryString.split("&");
        for (var i = paramArr.length - 1; i >= 0; i -= 1) {
          // eslint-disable-next-line prefer-destructuring
          param = paramArr[i].split("=")[0];
          if (param === key) {
            paramArr.splice(i, 1);
          }
        }

        url = url + "?" + paramArr.join("&");
      }
      return url;
    };

    this.splitQueryParams = function (queryParams) {
      var query = {};
      var pairs = (queryParams[0] === "?" ? queryParams.substr(1) : queryParams).split("&");
      for (var i = 0; i < pairs.length; i++) {
        var pair = pairs[i].split("=");
        query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || "");
      }
      return query;
    };
  }

  _createClass(BaseHelper, [{
    key: "getBgClassName",
    value: function getBgClassName(isActive) {
      var classes = "add-on-row section mx-0 align-items-md-center ";
      if (isActive) {
        classes += "active-bg";
        return classes;
      }
      return classes;
    }
  }, {
    key: "getDefaultProps",
    value: function getDefaultProps(componentName) {
      return _defaultProps2.default[componentName];
    }
  }, {
    key: "getPropValue",
    value: function getPropValue(type, key, value, groupId) {
      var storyBookMode = process.env.STORYBOOK_STORY_MODE;
      if (!storyBookMode) return value;

      if (type === "text") {
        var propValue = (0, _addonKnobs.text)(key, value, groupId);
        return propValue;
      }

      if (type === "boolean") {
        var _propValue = (0, _addonKnobs.boolean)(key, value, groupId);
        return _propValue;
      }

      return null;
    }
  }, {
    key: "getVideoIdId",
    value: function getVideoIdId(url) {
      var regExp = /^.*(youtu.be\/|v\/|u\/\w\/|embed\/|watch\?v=|&v=)([^#&?]*).*/;
      var match = url.match(regExp);

      var videoId = match && match[2].length === 11 ? match[2] : null;
      return videoId;
    }

    /**
     * @desc To get absolute url of image options
     *
     * @param {String} image
     *
     * @return {String} image url
     *
     */

  }, {
    key: "getImagePath",
    value: function getImagePath(image) {
      var imagePath = this.getRootUrl() + "/assets/";
      if (!image) {
        return imagePath;
      }

      return "" + imagePath + image;
    }

    /**
     * @desc To get request options
     *
     * @return options
     *
     */


    /**
     * @desc To set query params
     * @param location object
     * @param queryParams object
     *
     * @return query params
     *
     */

  }, {
    key: "getRootUrl",


    /**
     * @desc To get root url of current domain
     *
     * @return root url
     *
     */
    value: function getRootUrl() {
      return window.location.origin;
    }

    /**
     * @desc To check if valid url
     * @param url
     *
     * @return bool
     *
     */

  }, {
    key: "isValidURL",
    value: function isValidURL(url) {
      if (!url) {
        return false;
      }

      // eslint-disable-next-line max-len
      var validURLRegex = /^(?:(?:https?|ftp):\/\/)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,})))(?::\d{2,5})?(?:\/\S*)?$/;
      return validURLRegex.test(url);
    }

    /**
     * @desc To update query params
     * @param location object
     * @param key string
     *
     * @return url
     *
     */


    /**
     * @desc To  query params
     * @param queryParams string
     *
     * @return param array
     *
     */

  }]);

  return BaseHelper;
}();

exports.default = new BaseHelper();